export const emailTemplateInstanceID = {
    COLLECTION: 17,
    ASSET: 18
};